import { computed, observable, makeObservable } from "mobx";
import { IAutocomplete } from "../../modelo/Autocomplete";
import { Estrutura } from "../modelo/Estrutura";
import { DecisaoAM, DespachoAM, ITipoMinutaAM, VotoAM } from "../modelo/TipoMinutaAm";
import MinutaEdicaoStore from "./MinutaEdicaoStore";

class EstruturaStore {
    estruturaParaEdicao: Estrutura;
    estruturasFiltradas: Estrutura[] = [];
    estruturas: Estrutura[] = [];
    codigoTipoMinuta: number;

    constructor() {
        makeObservable(this, {
            estruturaParaEdicao: observable,
            estruturasFiltradas: observable,
            estruturas: observable,
            codigoTipoMinuta: observable,
            optionsEstruturasFiltradas: computed,
            estruturasFiltradasPeloTipo: computed,
            optionsEstruturasFiltradasPorTipoMinutaEmEdicao: computed
        });
    }

    get optionsEstruturasFiltradas(): IAutocomplete<Estrutura>[] {
        return this.estruturasFiltradas.map(estrutura => {
            return {
                valor: estrutura,
                texto: estrutura.nome,
                parametrosBusca: [estrutura.nome]
            }
        });
    }

    get estruturasFiltradasPeloTipo() {
        const codigoTipoMinuta = this.codigoTipoMinuta || MinutaEdicaoStore.tipoMinuta;
        let tipoMinuta: ITipoMinutaAM;
        if (codigoTipoMinuta === 3) {
            tipoMinuta = VotoAM;
        } else if (codigoTipoMinuta === 2) {
            tipoMinuta = DecisaoAM;
        } else {
            tipoMinuta = DespachoAM;
        }

        return this.estruturas.filter((estrutura) => {
            return estrutura.tipo.codigo === tipoMinuta.codigo;
        })
    }

    get optionsEstruturasFiltradasPorTipoMinutaEmEdicao(): IAutocomplete<Estrutura>[] {
        let tipoMinuta: ITipoMinutaAM;
        if (MinutaEdicaoStore.tipoMinuta === 3) {
            tipoMinuta = VotoAM;
        } else if (MinutaEdicaoStore.tipoMinuta === 2) {
            tipoMinuta = DecisaoAM;
        } else {
            tipoMinuta = DespachoAM;
        }

        return this.estruturasFiltradas.filter(estrutura => {
            return estrutura.tipo.codigo === tipoMinuta.codigo;
        }).map(estrutura => {
            return {
                valor: estrutura,
                texto: estrutura.nome,
                parametrosBusca: [estrutura.nome]
            }
        });
    }
}

export default new EstruturaStore();